import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function TransformationSection() {
  const outcomes = ['Apagas sin entrar en conversación infinita', 'El niño aprende "qué viene después" (y baja la ansiedad)', 'Las rabietas bajan porque hay transiciones, no arrancadas', 'Tú recuperas autoridad sin gritar', 'Vuelves a sentir que tú mandas.'];
  return <section className="w-full bg-[#F5EDE3] px-4 py-16 md:py-24" data-id="element-153">
      <div className="max-w-3xl mx-auto" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-155">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A] mb-10 font-serif text-center" data-id="element-156">
            Lo que pasa cuando lo haces bien
          </h2>

          <div className="bg-white rounded-2xl p-8 shadow-sm border border-[#E2E8F0]" data-id="element-157">
            <ul className="space-y-6" data-id="element-158">
              {outcomes.map((outcome, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start" data-id="element-159">
                  <CheckCircle2 className="h-6 w-6 text-[#2D6A4F] mt-0.5 mr-4 flex-shrink-0" data-id="element-160" />
                  <span className={`text-lg ${index === outcomes.length - 1 ? 'font-bold text-[#C4704B]' : 'text-[#1B2A4A]'}`} data-id="element-161">
                    {outcome}
                  </span>
                </motion.li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}